import { BpCard } from '../../../../shared/components/cards/card/BpCard'
import { Square } from '../../../../shared/components/utility/square/Square'
import { Controller, useForm } from 'react-hook-form'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { ProfileForm, usePostProfileInfoMutation } from '../../../../app/api'
import { FormControls } from '../../../../shared/components/forms/form-controls/FormControls'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './EditAccountForm.module.scss'

export interface IEditAccountFormData {
  username: string
  fio: string
  company: string
}

export const EditAccountForm = ({ className, data }: { className?: string; data: ProfileForm }) => {
  const { t } = useTranslation()
  const [editProfile] = usePostProfileInfoMutation()

  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid },
    reset,
    register,
  } = useForm<IEditAccountFormData>({
    mode: 'onChange',
    defaultValues: { ...data },
  })

  return (
    <Square className={className}>
      <form onSubmit={handleSubmit((data: IEditAccountFormData) => editProfile({ profileForm: data }))}>
        <BpCard
          footer={<FormControls disabled={!isDirty || !isValid} onCancel={() => reset()} />}
          title={t('pages.profile.editAccountInfo')}
        >
          <div className={clsx(styles.formFields)}>
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('username', { required: t('fields.validate.required') })}
                  required
                  error={error?.message}
                  label={t('pages.profile.fields.nickname')}
                  placeholder={t('pages.profile.fields.enterNickname')}
                />
              )}
              control={control}
              name='username'
            />
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('fio', {
                    required: t('fields.validate.required'),
                    minLength: {
                      value: 4,
                      message: t('pages.profile.fields.fullNameMinLength'),
                    },
                  })}
                  required
                  error={error?.message}
                  label={t('pages.profile.fields.fullName')}
                  placeholder={t('pages.profile.fields.enterFullName')}
                />
              )}
              control={control}
              name='fio'
            />
            <Controller
              render={({ field, fieldState: { error } }) => (
                <BpInput
                  {...field}
                  {...register('company', {
                    required: t('fields.validate.required'),
                    minLength: {
                      value: 4,
                      message: t('pages.profile.fields.companyNameMinLength'),
                    },
                  })}
                  required
                  error={error?.message}
                  label={t('pages.profile.fields.companyName')}
                  placeholder={t('pages.profile.fields.enterName')}
                />
              )}
              control={control}
              name='company'
            />
          </div>
        </BpCard>
      </form>
    </Square>
  )
}
